export default __webpack_public_path__ + "src/components/CoreLayout/components/Header/components/Menu/assets/cross-icon.svg";